import { ReactNode } from "react";
import { GuideContainer } from "./GuideContainer";

export enum WizardStepType {
  STEP="step",
  GUIDE_STEP="guideStep",
  HIDDEN_STEP="hiddenStep",
  HIDDEN_GUIDE_STEP="hiddenGuideStep"
}

export enum WizardButtonType {
  CONTINUE="continue",
  OPEN_CHAT="openChat",
  CALLBACK="callback",
}

export interface WizardButton {
  buttonType: WizardButtonType;
  text?: string;
  variant?: string;
  callback?: string;
  isFinalStep?: boolean;
}

export interface WizardStep {
  stepType: WizardStepType;
  id: string;
  minNumberContentSteps: number;
  maxNumberContentSteps: number;
  isFinalStep: boolean;

  showWizardButtons?: boolean;
  titleImage?: ReactNode;
  primaryButton?: WizardButton;
  secondaryButton?: WizardButton;
}

export type WizardStepContainer = WizardStep & GuideContainer;

export interface WizardContainer
{
  steps: WizardStepContainer[];
}
